<micro-select-combo #sel
              placeholder="Task Carrier Type"
              [mode]="mode"
              [(id)]="taskCarrierTypeId"
              (idChange)="change($event)"
              [options]="options"

              [required]="required"
              [disabled]="disabled"
>
</micro-select-combo>
